export class ContractPricingTier {
    /**
     * Tier applied if the sales total is less than or equal to this value
     */
    tierMonthlyAmount: number;

    /**
     * Fee percentage to apply if within the tier
     */
    feePercentage: number;

    stripeDomesticFeePercentage: number;
    stripeDomesticFeeFixed: number;
    stripeInternationalFeePercentage: number;
    stripeInternationalFeeFixed: number;
}

export class VenuePlanData {

    planName: string;

    venueSubscriptionType: string;

    /**
     * Transaction rate
     */
    feePercentage: number;
    feeFixed: number;
    overrideStripeFees: boolean;
    stripeDomesticFeePercentage: number;
    stripeDomesticFeeFixed: number;
    stripeInternationalFeePercentage: number;
    stripeInternationalFeeFixed: number;

    minWeeklySales: number;
    fixedMonthlyFee: number;

    preferredFeeCalculationMode: string = "SIMPLE";

    /**
     * Duration of the contract
     */
    months: number;

    customTerms: string;

    skipBillingCycles: number;
    skipBillingCyclesReason: string;

    initialTermStartDate: string;

    /**
     * Optional pricing tiers. If specified the chewzie fees (clips) are based on the
     * payments processed in the previous month
     */
    pricingTiers: ContractPricingTier[] = [];

    /**
     * Current tier which is index of pricingTiers + 1
     */
    currentTier: number;

    /**
     * Date to lock the current tier
     */
    lockTierUntilDate: string;

    /**
     * Indicates that the calculations for the tiered pricing is based on the group gross sales instead of the venue's.
     * If the venue is not configured with a group, then tiered pricing will not be adjusted
     */
    useGroupSalesForTieredPricing: boolean;

    /**
     * Name of the group to show in the contract
     */
    groupName: string;
}
